import { DataTableRequest } from 'components/data-table/types'
import api from 'services/inventory/equipment'

export const handleGetMaintenanceActions = async (request: DataTableRequest) => {
  let res = await api.searchMaintenanceActions(request)

  return res?.data ?? []
}
